import { render, staticRenderFns } from "./NhlScoring.vue?vue&type=template&id=5b890460&scoped=true"
import script from "./NhlScoring.vue?vue&type=script&lang=js"
export * from "./NhlScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b890460",
  null
  
)

export default component.exports